// Import model
import { SfWorkOrder } from '../models/SfWorkOrder';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SfWorkOrder - handles JSON serialization and deserialization with type validation
 */
export class SfWorkOrderSerializer {
  /**
   * Deserializes a JSON string into a SfWorkOrder instance
   */
  static deserialize(json: string): SfWorkOrder {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SfWorkOrder instance
   */
  static fromObject(obj: any): SfWorkOrder {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SfWorkOrder');
    }


    const instance: SfWorkOrder = {
      externalId: obj['externalId'] as string | undefined,
      projectNumber: obj['projectNumber'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      customerExternalId: obj['customerExternalId'] as string | undefined,
      customerExternalIdName: obj['customerExternalId|Name'] as string | undefined,
      address: obj['address'] as string | undefined,
      city: obj['city'] as string | undefined,
      state: obj['state'] as string | undefined,
      postalCode: obj['postalCode'] as string | undefined,
      description: obj['description'] as string | undefined,
      status: obj['status'] as string | undefined,
      customerNotes: obj['customerNotes'] as string | undefined,
      floorplanId: obj['floorplanId'] as string | undefined,
      floorplanIdName: obj['floorplanId|Name'] as string | undefined,
      inspectionNotes: obj['inspectionNotes'] as string | undefined,
      inspectionVideoId: obj['inspectionVideoId'] as string | undefined,
      inspectionVideoIdName: obj['inspectionVideoId|Name'] as string | undefined,
      leadExternalId: obj['leadExternalId'] as string | undefined,
      leadExternalIdName: obj['leadExternalId|Name'] as string | undefined,
      name: obj['name'] as string | undefined,
      notes: obj['notes'] as string | undefined,
      debriefNotes: obj['debriefNotes'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SfWorkOrder instances
   */
  static deserializeArray(json: string): SfWorkOrder[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SfWorkOrder instance to a JSON string
   */
  static serialize(instance: SfWorkOrder): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SfWorkOrder instance to a plain object
   */
  static toObject(instance: SfWorkOrder): any {
    return {
      'externalId': instance.externalId,
      'projectNumber': instance.projectNumber,
      'createdDate': instance.createdDate,
      'customerExternalId': instance.customerExternalId,
      'customerExternalId|Name': instance.customerExternalIdName,
      'address': instance.address,
      'city': instance.city,
      'state': instance.state,
      'postalCode': instance.postalCode,
      'description': instance.description,
      'status': instance.status,
      'customerNotes': instance.customerNotes,
      'floorplanId': instance.floorplanId,
      'floorplanId|Name': instance.floorplanIdName,
      'inspectionNotes': instance.inspectionNotes,
      'inspectionVideoId': instance.inspectionVideoId,
      'inspectionVideoId|Name': instance.inspectionVideoIdName,
      'leadExternalId': instance.leadExternalId,
      'leadExternalId|Name': instance.leadExternalIdName,
      'name': instance.name,
      'notes': instance.notes,
      'debriefNotes': instance.debriefNotes,
    };
  }

  /**
   * Serializes an array of SfWorkOrder instances to a JSON string
   */
  static serializeArray(instances: SfWorkOrder[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
